
<template>
    <div>
    <el-dialog :title="title"  @close="close" :visible.sync="dialogcold">
         <avue-form ref="formstate" v-model="formstate" :rules="rules" :option="option">
            <template slot-scope="scope" slot="menuForm">
                <el-button  @click="handleEmpty">取 消</el-button>
                <el-button type="primary" @click="update">确 定</el-button>
            </template>
        </avue-form>
    </el-dialog>
    </div>
</template>
<script>
    import {stop} from '@/api/admin/workerUser'
    import {getImgLink} from '@/config/env'
    import {mapGetters} from 'vuex'
    import {dateOnce} from '@/util/dateT'
    import {objKeySort } from '@/util/ajaxsign'
    
    export default {
        data() {
            return {
                title : '',
                companyId : '',    
                dialogcold : false,
                formstate : {
                    tips : '',
                },
               option:{
                    emptyBtn:false,
                    submitBtn:false,
                    submitText : '确定',
                    column: [ {
                    label: "",
                    prop: "tips",
                    disabled : false,
                    span:24,
                    rules : [
                        {required: true, message: '请输入原因', trigger: 'blur' }
                    ]
                }]
            }
        }
        },
        created() {},
        mounted() {},
        methods: {
            //刷新列表操作
            refresh(){
                this.getCompanyInfo(this.projectId);
            },
            //设置展示
            setsataus(data,name){
                this.title = name;
                this.dialogcold = true;
                this.companyId = data;
                this.option.column[0].label = name;
            },

            update(){
                  this.$refs.formstate.validate(vaild=>{
                       if(vaild){
                            if(this.title == "冻结原因"){
                                this.handleStop1();
                            }else{
                                this.handlerzfalse();
                            }
                        }
                  })
               
            },

            //项目详情数据请求
            handleStop1(){
                stop(objKeySort({userId:this.companyId,status:4,tips:this.formstate.tips})).then(response =>{
                this.$message({
                    title: '冻结成功',
                    message: '冻结成功',
                    type: 'success',
                    duration: 2000
                    })
                    this.dialogcold = false;
                    this.$emit('refresh');
                })    
            },

            //实名认证不通过
            handlerzfalse(){
                stop(objKeySort({userId:this.companyId,status:1,tips:this.formstate.tips})).then(response =>{
                this.$message({
                    title: '冻结成功',
                    message: '冻结成功',
                    type: 'success',
                    duration: 2000
                    })
                    this.dialogcold = false;
                    this.$emit('refresh');
                })    
            },

            //默认时间
            settime(data){
                return dateOnce(data)
            },
           

            //取消回调
            close(){
                console.log(1234567894548)
                 this.$refs.formstate.resetForm();
            },

            handleEmpty(){
                this.dialogcold = false;
            },
      
            isworkstate(data){
                // 0或空，未认证；1，审核中；2审核通过；3拒绝审核
                if(data == '1'){
                    return  '审核中'
                }else if(data == '2'){
                    return  '已实名'
                }else if(data == '3'){
                    return  '拒绝审核'
                }else{
                    return  '未实名'
                }
            }
        }
    }
</script>

<style lang="scss" scoped>
.container{
    min-width:800px;
    max-width:900px;
}
.form_layout_items{
    display:flex
}
.select_option{
    position: absolute;
    z-index: 22;
    width: 150px !important;
    right: 0;
    top: 0;
}
.el-table ::v-deep .el-table__row:nth-child(even) {
    background-color: #F6F9FF !important;
  }
  .form_layout_item{
      width:50%;
      border:1px solid #fff;
      height:80px;
  }
</style>